import styled from "styled-components";

export const StyledBaseButton = styled.button.attrs(() => ({
  className: `btn normal-case`,
}))``;
